import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular } from '@fortawesome/fontawesome-svg-core/import.macro';
function CustomerERPModel({
  customerERPModel,
  setCustomerERPModel,
  customers,
  customerERP,
  setCustomerERP,
}) {
  // The open/closed state lives outside of the Dialog and is managed by you

  function handleDeactivate(account) {
    setCustomerERP(account);
    setCustomerERPModel(false);
  }

  return (
    <>
      <Transition appear show={customerERPModel} as={Fragment}>
        <Dialog
          as='div'
          className='relative  z-30'
          onClose={() => setCustomerERPModel(false)}
        >
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-25' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto' dir='rtl'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                  <Dialog.Title
                    as='h3'
                    className='text-lg font-medium leading-6 text-gray-900 text-right'
                  >
                    حسابات العميل
                  </Dialog.Title>
                  <div className='mt-10 grid grid-cols-3 gap-4'>
                    {customers.map((account) => (
                      <div
                        key={account.accountCode}
                        className='  border-black shadow-2xl rounded-lg p-4  bg-white pt-8 px-8 w-full'
                      >
                        <div className=' flex flex-col'>
                          <div>
                            <h3 className='text-lg text-title-100 pb-6 border-b-2 border-gray-300 text-right'>
                              {account?.custName || account?.accountCode}
                            </h3>

                            <div className='mt-6 text-lg text-title-100 flex flex-row '>
                              <p>
                                <FontAwesomeIcon
                                  icon={solid('phone-flip')}
                                  color='#7367F0'
                                  size='sm'
                                />
                              </p>
                              <p className=' text-lg text-title-100 pr-2 align-middle'>
                                {account?.phoneLocal}
                              </p>
                            </div>
                          </div>

                          <div className='mt-2 pb-6 text-lg text-title-100 flex flex-row '>
                            <p>
                              <FontAwesomeIcon
                                icon={solid('location-dot')}
                                color='#7367F0'
                                size='sm'
                              />
                            </p>
                            <p className=' text-lg text-title-100 pr-2 align-middle'>
                              {account?.stateId} - {account?.city}
                            </p>
                          </div>
                          <div className='flex mx-auto'>
                            <button
                              type='button'
                              onClick={() => handleDeactivate(account)}
                              className='text-white bg-button-100 hover:bg-blue-800  rounded-md  font-medium  text-sm px-10 py-2 mb-2    '
                            >
                              الاستمرار
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default CustomerERPModel;
